import {
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  useDisclosure,
} from "@chakra-ui/react";
import { MenuItemLink } from "@components/ui-kit";
import { Trans, t } from "@lingui/macro";
import { useDeleteContractorMutation } from "@src/__generated__/graphql";
import type { Contractor } from "@src/__generated__/urql-graphql";
import { ModalConfirm } from "@src/components/ui-kit";
import { Icon } from "@src/components/ui-kit/Icon";
import { onError } from "@src/utils/apollo";
import { can } from "@src/utils/components/permissions";
import { useStore } from "@src/utils/hooks";
import React, { type FunctionComponent, useContext } from "react";
import { PageContractorsCtx } from "../PageContractors";

export const PopoverRowActions: FunctionComponent<
  React.PropsWithChildren<{ id: Contractor["id"] }>
> = ({ id }) => {
  const appStore = useStore();
  const store = useContext(PageContractorsCtx);

  const [deleteContractor] = useDeleteContractorMutation({
    variables: { id },
    ...onError(),
    onCompleted() {
      store.refetch?.();
      appStore.UIStore.toast({
        title: t`The contractor was deleted`,
        status: "success",
      });
    },
  });
  const deleteContractorDialog = useDisclosure();

  return (
    <React.Fragment>
      <Menu>
        <MenuButton
          as={IconButton}
          colorScheme="grey"
          icon={<Icon name="dots-horizontal" />}
          variant="plain"
        />

        <MenuList>
          {can("contractor_update") && (
            <MenuItemLink
              href={{ pathname: "/contractors/detail", query: { id } }}
            >
              <Trans>Edit</Trans>
            </MenuItemLink>
          )}
          {can("contractor_delete") && (
            <MenuItem onClick={deleteContractorDialog.onOpen}>
              <Trans>Delete</Trans>
            </MenuItem>
          )}
        </MenuList>
      </Menu>

      <ModalConfirm {...deleteContractorDialog} onConfirm={deleteContractor} />
    </React.Fragment>
  );
};
